module.exports = __webpack_public_path__ + "static/media/tab_finance.d2b38ed2.png";